// extracted by mini-css-extract-plugin
module.exports = {"button":"InfographicExpandButton_button__2r5pv","button-wrapper":"InfographicExpandButton_button-wrapper__cf_MA","buttonWrapper":"InfographicExpandButton_button-wrapper__cf_MA"};